import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <p-toast [style]="toastStyle">
      <ng-template let-message pTemplate="message">
        <span>{{ message.detail }}</span>
      </ng-template>
    </p-toast>
  `
})
export class AppComponent {
  /**
   * Held as a field, not written inline in the template.
   *
   * `[style]="{ marginTop: '50px' }"` builds a NEW object on every
   * change-detection pass, so the toast sees a changed input every pass and
   * asks for another one. This is the root component, so that runs on every
   * page in the app. A stable reference costs nothing and settles it.
   */
  public readonly toastStyle = { marginTop: '50px' };
}
